import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SiteActions } from '@/redux/site/actions';
import { AppDispatch } from '@/store';
import { BtnRed } from '@/components/Buttons/BtnRed';
import { ScrollDown } from '@/components/ScrollDown';
import { ObserverContainer } from '@/components/ObserverContainer';
import { breakText } from '@/modules/utils';
import { WrapWordsAndLetters } from '@/components/WrapWordsAndLetters';

export const EmpoweringPlayers = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(SiteActions.loadSite());
  }, [dispatch]);

  return (
    <div className="empowering-container">
      <div className="content-wrapper">
        <div className="layout-image" />
        <div className="container flex">
          <div className="left-content">
            <ObserverContainer className="content">
              <p className="highlighted">ABOUT XBORG</p>

              <h1 className="integralfc-h1 reveal-from-bottom">
                <WrapWordsAndLetters sentence="Empowering players & fans" />
              </h1>
              <p className="description">
                We’re a global team on a mission to build the next-generation of
                gaming, where players and fans experience ownership, and
                governance and are rewarded for their contributions.
              </p>

              <div className="actions flex">
                <BtnRed
                  label="Join Discord"
                  href="https://discord.com/invite/xborg"
                  className="btn-discord"
                />
              </div>
            </ObserverContainer>
          </div>
          <div className="right-content"></div>
        </div>
      </div>
      <ScrollDown anchor="about-container" />
    </div>
  );
};
